var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"etf-wrapper"},[_c('FundBasic',{staticClass:"section-margin"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }